(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const menu=event.target.closest('.sd-mobile-nav');if(menu&&event.target.closest('a'))menu.open=false;});document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.sd-mobile-nav[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',event=>{const input=event.target;if(!input.matches('.sd-product-form input[name="id"]'))return;const form=input.closest('form');const price=form.querySelector('[data-sd-price]');if(price)price.textContent=input.dataset.price;});
function syncSuperdotsPrices(){document.querySelectorAll('.sd-product-form input[name="id"]:checked').forEach(input=>{const price=input.closest('form').querySelector('[data-sd-price]');if(price)price.textContent=input.dataset.price;});}
window.addEventListener('pageshow',syncSuperdotsPrices);
document.addEventListener('DOMContentLoaded',syncSuperdotsPrices);
syncSuperdotsPrices();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-quiz"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit',event=>{if(!event.target.matches('.sd-quiz-form'))return;event.preventDefault();const form=event.target;const root=form.closest('.sd-quiz');const need=form.querySelector('[name="need"]:checked').value;const stock=form.querySelector('[name="amount"]:checked').value==='stock';const key=need==='both'&&stock?'pair':need;const result=root.querySelector('.sd-quiz-results');result.querySelectorAll('[data-quiz-product],[data-quiz-variant]').forEach(el=>el.hidden=true);const card=result.querySelector('[data-quiz-product="'+key+'"]');if(!card)return;card.hidden=false;const variants=card.querySelectorAll('[data-quiz-variant]');if(variants.length)variants[stock?variants.length-1:0].hidden=false;form.hidden=true;result.hidden=false;result.focus();});
document.addEventListener('click',event=>{if(!event.target.closest('.sd-quiz-reset'))return;const root=event.target.closest('.sd-quiz');root.querySelector('.sd-quiz-results').hidden=true;const form=root.querySelector('.sd-quiz-form');form.hidden=false;form.reset();form.querySelector('input').focus();});

  } catch(e) { console.error(e); }
})();
})();
